export default __webpack_public_path__ + "static/media/ethan_sarpong.43bef045.jpg";